import { Button, ButtonProps, ConfigProvider, Tooltip } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

interface ButtonWithTooltipProps extends ButtonProps {
  title: string;
}
export const ButtonWithTooltip = ({
  title,
  onClick,
  ...props
}: ButtonWithTooltipProps) => {
  const { theme } = useAntTheme();
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultBg: "transparent",
            defaultBorderColor: "transparent",
            defaultColor: theme.colorBgBase,
            defaultHoverBorderColor: "transparent",
            fontSize: 18,
          },
        },
      }}
    >
      <Tooltip title={title}>
        <Button size="small" onClick={onClick} {...props}>
          {props.children}
        </Button>
      </Tooltip>
    </ConfigProvider>
  );
};
